<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Redeem Points For rewards</h1>
    </div>

    <div class="container">
      <br>
      <!-- <div class="row">
        <a
          type="button"
          class="btn client-btn-primary btn-lg text-uppercase col-md-6 col-md-offset-3"
          @click.prevent="skipAddingItem"
        >
          Skip Adding Item
        </a>
      </div> -->
      Sort by points: <button class="btn btn-md btn-default" @click="pointsAsc = !pointsAsc">{{ pointsAsc ? 'High to Low' : 'Low to High' }}</button>
      <div
        class="row text-center"
        v-for="i in Math.ceil(sortedItems.length / 4)" :key="i"
        >
        <div
          class="col-md-3 col-sm-6"
          v-for="(item, index) in sortedItems.slice((i - 1) * 4, i * 4)" :key="index"
        >
          <div class="reward-box">
            <div class="image-container">
              <img :src="item.image ? item.image.url : ''" class="img-responsive center-block" :alt="item.name">
            </div>
            <!-- <img src="../../../assets/images/rewards/hat.jpg" class="img-responsive center-block" :alt="item.name"> -->
            <div class="item-details">
              <span class="grey-type lrg-numbers"><strong>{{ item.points }}</strong></span><br>
              <h1 class="text-capitalize">{{ item.name }}</h1><br>
              <a
                href=""
                type="button"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="goRewardDetail(item)"
              >
                Select Item
              </a>
            </div>
            <br>
          </div>
        </div>

      </div><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RewardCatalog',
  data () {
    return {
      pointsAsc: true,
      sortByPoints: (a, b) => {
        return this.pointsAsc ? a.points - b.points : -1 * (a.points - b.points)
      }
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'rewardItems'
    ]),
    sortedItems () {
      return this.rewardItems
        .filter(item => item.points !== undefined && !item.archived)
        .sort(this.sortByPoints)
    }
  },
  methods: {
    goRewardDetail (item) {
      this.$bus.emit('swapComponent', { component: 'reward-detail', props: { rewardItem: item } })
    },
    skipAddingItem () {
      this.$bus.emit('swapComponent', { component: 'cart-items' })
    }
  }
}
</script>

<style scoped>
.lrg-numbers {
  font-size: 3em;
}

.image-container {
}

.image-container img {
  height: 200px;
}

.item-details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 5px;
}

.reward-box .item-details h1 {
  margin:-15px;
  padding:0px;
  font-weight: 300;
  flex-grow: 1;
  max-height: 112px;
  overflow-y: auto;
  overflow-wrap: break-word;
  font-size: 24px;
}

.reward-box{
  height: 450px;
  border: 1px solid rgba(42, 42, 42,.60);
  padding: 10px;
  -webkit-box-shadow: 0px 0px 5px rgba(42, 42, 42,0.75);
  box-shadow: 0px 0px 5px rgba(42, 42, 42,0.75);
  margin-top:20px;
  margin-bottom:20px;
  display: flex;
  flex-direction: column;
}

</style>
